var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "StoneCutFrench",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-stone-cut-french","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M0-.5v250h250V-.5H0zM217.2 117l-30.3-30.2L241 20.6v3L217.2 117zM95 180l32.8-26.5 30.1 24.3-32.9 32.8L95 180zm30-142.1l34 33.9L127.9 97l-34-27.4L125 37.9zm47.5 34.6l41.6-33.3-33.7 41.2-7.9-7.9zm2.2 14.9l-26.1 31.2-14.4-15.1 31.4-25.3 9.1 9.2zM127.4 141l-15.8-15.8 15.8-15.8 15.1 15.8-15.1 15.8zm-6.3-37.9l-15.7 15.7-27.2-33.2 9.4-9.5 33.5 27zM72.5 78.6L37.9 36.3l42.6 34.1-8 8.2zM71.9 92L99 125.2l-26.2 32.1-32.5-33.1L71.9 92zm9.8 87.2l-43.8 35 35.5-43.5 8.3 8.5zm-2.6-15.4l26.2-32.1 15.7 15.7-32.4 26.1-9.5-9.7zm55-16.8l14.4-15 25.2 30-9.4 9.4-30.2-24.4zm45.4 21.9l34.6 42.3-42.7-34.2 8.1-8.1zm.6-13.3l-25.5-30.3 26.5-31.6 30.5 30.4-31.5 31.5zm-14-89.5l-34.7-34.6 94.1-23.1h12.6l-72 57.7zM125 23.9L66.1 8.5h121.6L125 23.9zm-6.3 7.6L86.9 63.9 17.6 8.5h12.8l88.3 23zM66.1 85l-32.9 33.5L9 23.6v-8.4L66.1 85zm-40.8 39.1L9 184.4V60l16.3 64.1zM9 218.8l24.2-89 33.9 34.6L9 235.3v-16.5zm79-33.1l30.7 31.3-88.8 23.2.1.4H19.5L88 185.7zm37 38.9l64.7 15.9H64.2l60.8-15.9zm6.4-7.7l33.6-33.5 71.3 57.1H226l.1-.4-94.7-23.2zm54.5-54.4l31.3-31.3 23.7 87.5v11.1l-55-67.3zm38.8-38.4L241 60v124.4l-16.3-60.3z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/stone-cut-french.svg